import {
  ActionList,
  ActionListItem,
  Dropdown,
  DropdownOverlay,
  FilterChipGroup,
  FilterChipSelectInput,
  ListViewFilters,
} from '@razorpay/blade/components';
import useIsFeatureDisabledForRearch from 'access/useIsFeatureDisabledForRearch';
import {
  deductionFiltersMap,
  deductionTypeFilters,
  taxabilityFilters,
} from 'components/SalaryComponents/constants';
import { useFilters } from 'hooks/useFilters';
import { PaginationFiltersMap } from 'hooks/usePagination';
import React from 'react';
import StatusFilter, { StatusFilterKeyType } from './StatusFilter';

const DeductionsFilters = ({ counts }: { counts?: Record<StatusFilterKeyType, number> }) => {
  const { currentFilters, applyFilter, getSelectedFiltersCount, removeFilter } = useFilters({
    filtersMap: deductionFiltersMap,
    multipleValueFilters: [deductionFiltersMap.taxability],
  });
  const { isM2S1Enabled, isM2S2Enabled } = useIsFeatureDisabledForRearch();

  const selectedFiltersCount = getSelectedFiltersCount(currentFilters, [
    PaginationFiltersMap.page,
    PaginationFiltersMap.limit,
    deductionFiltersMap.status,
  ]);

  const deductionType = currentFilters[deductionFiltersMap.deduction_type];

  const selectedDeductionType = deductionType in deductionTypeFilters ? deductionType : '';

  const taxability = currentFilters[deductionFiltersMap.taxability] as string[];
  const selectedTaxability = [...new Set(taxability)].filter((item) => item in taxabilityFilters);

  return (
    <>
      <ListViewFilters
        quickFilters={<StatusFilter counts={counts} />}
        selectedFiltersCount={selectedFiltersCount}>
        <FilterChipGroup
          onClearButtonClick={() =>
            removeFilter([deductionFiltersMap.deduction_type, deductionFiltersMap.taxability])
          }>
          <Dropdown selectionType="single">
            <FilterChipSelectInput
              onClearButtonClick={() => removeFilter(deductionFiltersMap.deduction_type)}
              name={deductionFiltersMap.deduction_type}
              label="Deduction Type"
              value={selectedDeductionType}
              onChange={({ values }) => {
                if (values.length === 0) {
                  removeFilter(deductionFiltersMap.deduction_type);
                } else {
                  applyFilter(deductionFiltersMap.deduction_type, values[0]);
                }
              }}
              accessibilityLabel="deduction type filter"
            />

            <DropdownOverlay>
              <ActionList>
                {Object.entries(deductionTypeFilters(isM2S1Enabled, isM2S2Enabled)).map(([filterKey, filterValue]) => {
                  return (
                    <ActionListItem
                      key={filterKey}
                      title={filterValue.label}
                      value={filterKey}
                      isDisabled={filterValue.isDisabled}
                    />
                  );
                })}
              </ActionList>
            </DropdownOverlay>
          </Dropdown>

          <Dropdown selectionType="multiple">
            <FilterChipSelectInput
              onClearButtonClick={() => removeFilter(deductionFiltersMap.taxability)}
              name={deductionFiltersMap.taxability}
              label="Taxability"
              value={selectedTaxability}
              onChange={({ values }) => {
                if (values.length === 0) {
                  removeFilter(deductionFiltersMap.taxability);
                } else {
                  applyFilter(deductionFiltersMap.taxability, values);
                }
              }}
              accessibilityLabel="taxability filter"
            />
            <DropdownOverlay>
              <ActionList>
                {Object.entries(taxabilityFilters).map(([filterKey, filterValue]) => {
                  return (
                    <ActionListItem
                      key={filterKey}
                      title={filterValue}
                      value={filterKey}
                      testID={filterValue}
                    />
                  );
                })}
              </ActionList>
            </DropdownOverlay>
          </Dropdown>
        </FilterChipGroup>
      </ListViewFilters>
    </>
  );
};

export default DeductionsFilters;
